import { sm4 } from 'sm-crypto';

const DEFAULT_SM4_KEY = '0123456789abcdeffedcba9876543210';
const DEFAULT_SM4_IV = '0123456789abcdeffedcba9876543210';

export const getTransmissionSm4KeyId = (): string => {
  return localStorage.getItem('transmission_sm4_key_id') || 'gm-sm4-v1';
};

export const getTransmissionSm4Key = (): string => {
  return localStorage.getItem('transmission_sm4_key') || DEFAULT_SM4_KEY;
};

export const getTransmissionSm4Iv = (): string => {
  const iv = localStorage.getItem('transmission_sm4_iv');
  if (iv === null) return DEFAULT_SM4_IV;
  return iv;
};

/**
 * CBC 模式加密
 * @param plainText 明文
 * @returns 十六进制密文
 */
export const encryptSM4_CBC = (plainText: string): string => {
  const key = getTransmissionSm4Key();
  const iv = getTransmissionSm4Iv() || key;
  return sm4.encrypt(plainText, key, {
    mode: 'cbc',
    iv: iv,
    // 注意：这里必须是 'pkcs#7'，带 # 号
    padding: 'pkcs#7',
  });
};

/**
 * CBC 模式解密
 * @param cipherTextHex 十六进制密文
 * @returns 明文
 */
export const decryptSM4_CBC = (cipherTextHex: string): string => {
  const key = getTransmissionSm4Key();
  const iv = getTransmissionSm4Iv() || key;
  return sm4.decrypt(cipherTextHex, key, {
    mode: 'cbc',
    iv: iv,
    // 注意：这里必须是 'pkcs#7'，带 # 号
    padding: 'pkcs#7',
  });
};
